const MAX_PARENT_TRAVERSAL_FOR_FEEDBACK = 5;

/**
 * @param {string} key
 * @return {string}
 */
function getSelector(key) {
	return `input[name='${key}'],select[name='${key}'],textarea[name='${key}']`;
}

/**
 * @param {Element} container
 * @param {Object.<string, *>} values
 */
function fillInputsByName(container, values) {
	Object.keys(values).forEach(key => {
		container.querySelectorAll(getSelector(key)).forEach(input => {
			switch (input.type) {
				case 'checkbox':
					input.checked = !!values[key];
					break;
				case 'radio':
					// Only check it if the value matches the selected value
					input.checked = values[key] === input.value;
					break;
				default:
					input.value = values[key];
					break;
			}

		})
	})
}

/**
 * @param {Element} container
 * @param {string[]} fields
 */
function clearInputsByName(container, fields) {
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			if (
				input.type === 'radio' ||
				input.type === 'checkbox'
			) {
				input.checked = false;
			} else {
				input.value = '';
			}
		})
	});
}

/**
 * @param {Element} container
 * @param {string[]} fields
 * @return {Object.<string, *>}
 */
function getInputsByName(container, fields) {
	const values = {};
	fields.forEach(field => {
		container.querySelectorAll(getSelector(field)).forEach(input => {
			switch (input.type) {
				case 'checkbox':
					values[field] = input.checked;
					break;
				case 'radio':
					if (input.checked) {
						values[field] = input.value;
					}
					break;
				default:
					// Basic field retrieval
					values[field] = input.value;
					break;
			}
		})
	});

	return values;
}

/**
 * Copy of getInputsByName ^ the only difference is it will return
 * checkbox fields whether they are checked or not, created as a new function
 * because the previous one is used everywhere and for both old and new code
 *
 * @param container
 * @param fields
 * @param removeFromKeys
 * @return {{}}
 */
function getInputsByNameV2(container, fields, removeFromKeys = []) {
	// noinspection DuplicatedCode
	const values = {};
	fields.forEach(field => {
		let found = false;
		let value = '';
		container.querySelectorAll(getSelector(field)).forEach(input => {
			const inputType = input.type;

			found = true;
			if (inputType === 'checkbox') {
				value = input.checked;
			} else if (inputType === 'radio') {
				// Radio type found
				// Get the selected radio
				// This mean it runs once for each radio button, not efficient
				// but lets keep it simple
				const selectedRadio = document.querySelector(`input[name="${field}"]:checked`);
				if (selectedRadio) {
					value = selectedRadio.value
				} else {
					value = false;
				}
			} else {
				// Treat normally
				value = input.value;
			}
		})

		if (found) {
			removeFromKeys.forEach(string => {
				field = field.replace(string, '');
			});
			values[field] = value;
		}
	});

	return values;
}

/**
 * Removes all feedback from the inputs with the names from fields arguments
 * If fields array is not provided will remove all feedback from container
 *
 * @param {Element} container
 * @param {string[]} [fields]
 */
function clearFeedbacksByName(container, fields) {
	if (fields) {
		fields.forEach(field => {
			container.querySelectorAll(getSelector(field)).forEach(input => {
				input.classList.remove('is-invalid');

				// Remove related feedback
				const feedbackContainer = findRelatedFeedback(input);
				if (feedbackContainer) {
					feedbackContainer.classList.remove('d-block');
					feedbackContainer.innerHTML = '';
				}
			})
		});
	} else {
		container.querySelectorAll('.is-invalid').forEach(element => {
			element.classList.remove('is-invalid');
		})
		container.querySelectorAll('.invalid-feedback').forEach(feedback => {
			feedback.classList.remove('d-block');
			feedback.innerHTML = '';
		})
	}
}

/**
 * @param {Element} element
 * @return {Element|undefined}
 */
function findRelatedFeedback(element) {
	let parentsTraversed = 1
	while (element.parentElement) {
		if (parentsTraversed > MAX_PARENT_TRAVERSAL_FOR_FEEDBACK) {
			break;
		}
		const feedbackContainer = element.parentElement.querySelector('.invalid-feedback');
		if (feedbackContainer) {
			return feedbackContainer;
		}
		// Not found, get next parent
		element = element.parentElement;
		parentsTraversed++;
	}

	// Feedback container not found
	return undefined;
}

export {
	fillInputsByName,
	clearInputsByName,
	getInputsByName,
	getInputsByNameV2,
	clearFeedbacksByName,
	MAX_PARENT_TRAVERSAL_FOR_FEEDBACK
}

